import { isStaleBuildError } from "../utils/staleBuild";

/**
 * Ganzseitiger Fallback, wenn ein unbehandelter Render-Fehler die App abstürzen
 * lässt (Sentry.ErrorBoundary in index.jsx). Reload ist der einzige sinnvolle
 * Ausweg, da der React-Baum ab hier als beschädigt gilt.
 */
function ErrorFallback({ error }) {
  const isStaleBuild = isStaleBuildError(error);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="alert alert-danger text-center" role="alert" style={{ maxWidth: "480px" }}>
        <h4>{isStaleBuild ? "Seite konnte nicht geladen werden" : "Etwas ist schiefgelaufen"}</h4>
        <p>
          {isStaleBuild
            ? "Vermutlich wurde die Anwendung gerade aktualisiert oder die Verbindung ist unterbrochen. Bitte die Seite neu laden."
            : "Die Anwendung ist auf einen unerwarteten Fehler gestoßen. Der Fehler wurde automatisch gemeldet."}
        </p>
        <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
          {isStaleBuild ? "Neu laden" : "Seite neu laden"}
        </button>
      </div>
    </div>
  );
}

export default ErrorFallback;
